import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "common/api/BaseQuery";
import { FilterProduct, ProductCollectionJson } from "../types/product.type";

export const productApi = createApi({
	reducerPath: "productApi",
	baseQuery: baseQuery(true),
	endpoints: (builder) => ({
		getDataProduct: builder.query<ProductCollectionJson, FilterProduct>({
			query(params) {
				return {
					url: `/products/public`,
					params: params,
				};
			},
			transformResponse(
				baseQueryReturnValue: ProductCollectionJson,
				meta,
				arg
			) {
				// Access the headers from the meta object
				const headers = meta?.response?.headers;
				// You can then do whatever you need with the headers
				console.log(headers);

				// Modify the response data as needed
				// const modifiedData = doSomethingWithResponse(baseQueryReturnValue);

				return baseQueryReturnValue;
			},
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDataProductQuery } = productApi;
